<template>
  <header ref="header" :class="['header', mode, {mobile: isMobile}]">
    <div class="nav-container">
      <div>
        <p class="title">第九工场</p>
        <a href="/">
          <img
            :src="`${ossBaseUrl}s/logo/${mode}.png`"
            :class="['logo', {mobile: isMobile }]"
            alt="第九工场,二维码, 艺术二维码,二维码设计, 二维码生成器,  二维码图片,二维码制作,二维码美化,创意二维码,二维码创意,彩色二维码,动态二维码,二维码营销"
            title="第九工场,二维码, 艺术二维码,二维码设计, 二维码生成器,  二维码图片,二维码制作,二维码美化,创意二维码,二维码创意,彩色二维码,动态二维码,二维码营销"
          />
        </a>
      </div>
      <nav class="nav">
        <a
          v-for="{ path, name } of navs"
          :key="path"
          :href="path"
          :class="['nav-link', {active: path === '/', mobile: isMobile }]"
          >{{ name }}</a
        >
      </nav>
    </div>
  </header>
</template>

<script>
import {isMobile} from "@/common/utils";
import {ossBaseUrl} from "@/main";
export default {
  name: "AppHeader",
  data() {
    return {
      ossBaseUrl,
      mode: "white", // black | white
      blackModePaths: ["/"],
      isSearch: false,
      isMobile: isMobile(),
      navs: [
        {
          path: "//909th.com/",
          name: "模板",
        },
        {
          path: "//909th.com/works",
          name: "作品",
        },
        {
          path: '/',
          name: '定制',
        },
        {
          path: "//909th.com/article",
          name: "文章",
        },
        {
          path: "//909th.com/plan",
          name: "会员",
        },
        // {
        //   path: '/explain',
        //   name: '说明',
        // },
      ],
      dropMenus: [],
    };
  },
  mounted() {},
  methods: {
    toBlackMode() {
      this.mode = "black";
      this.isSearch = false;
      if (process.browser) window.addEventListener("scroll", this.toggle);
    },
    toWhiteMode() {
      this.mode = "white";
      this.isSearch = true;
      if (process.browser) window.removeEventListener("scroll", this.toggle);
    },
    toggle() {
      const { scrollTop } = document.documentElement;
      const { offsetHeight } = this.$refs.header;
      const isOverflow = scrollTop > offsetHeight;
      this.mode = isOverflow ? "white" : "black";
      this.isSearch = isOverflow;
    },
    toggleMode(path) {
      if (
        this.blackModePaths.includes(path) ||
        path.includes("topic") ||
        path.includes("festival") ||
        path.includes("industry") ||
        path.includes("style") ||
        path.includes("all")
      ) {
        this.toBlackMode();
      } else {
        this.toWhiteMode();
      }
    },
  },
  beforeDestroye() {
    if (process.browser) window.removeEventListener("scroll", this.toggle);
  },
};
</script>
<style lang="less" scoped>
@import "../../styles/index";
@import "../../styles/variables";
.header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;
  transition: 0.5s background-color, color;
  &.mobile {
    .nav-container {
      padding: 1.6rem 3.2rem;
    }
  }

  .nav-container {
    position: relative;
    &:extend(.align-items-center);
    &:extend(.justify-between);
    padding: @space-base @space-lg;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    &:extend(.m-clear);
    display: none;
    font-size: @font-size-lg + 2;
  }
  .logo {
    display: block;
    height: 30px;
    &.mobile {
      height: 3rem
    }
  }
  .nav {
    &:extend(.align-items-center);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .nav-link {
      display: inline-block;
      font-size: @font-size-md;
      margin: 0 @space-base;
      &:hover,
      &:active,
      &.active,
      &.nuxt-link-exact-active {
        color: @c-primary;
      }
      &.mobile {
        font-size: 1.6rem;
        margin: 0 1.6rem;
      }
    }
  }
  /deep/ .search-complete {
    visibility: hidden;
    .ant-select-selection {
      background-color: transparent;
    }
    &.show {
      visibility: visible;
    }
  }
  /deep/ .mini-search {
    width: 250px;
    input,
    button {
      border: none;
      border-radius: 0;
      background: none;
      box-shadow: none;
    }
    span,
    button {
      background-color: transparent !important;
      box-shadow: none;
    }
    .ant-input-search-icon {
      color: @c-primary;
      font-size: @font-size-sm * 1.8;
      padding: 0 @space-xs;
    }
  }
  .tools {
    &:extend(.m-clear);
    &:extend(.align-items-center);
    > li {
      padding: 0 @space-xs;
    }
  }

  &.white {
    background-color: @c-white;
    color: @c-text;
    border-bottom: 1px solid @c-border;

    .title,
    .nav-link,
    .mini-search /deep/ input,
    .tools .link {
      color: @c-text;
    }

    .mini-search /deep/ input {
      border-bottom: 1px solid @c-text-lighter;
    }

    .tools > li + li {
      .pipe-space(@c-text);
    }
  }
  &.black {
    background-color: @bg-header;
    color: @c-text-inverse;

    .title,
    .nav-link,
    .mini-search /deep/ input,
    .tools .link {
      color: @c-text-inverse;
    }

    .mini-search /deep/ input {
      border-bottom: 1px solid @c-text-inverse;
    }

    .tools > li + li {
      .pipe-space(@c-text-inverse);
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
  }
}

.dropdown-menu {
  li {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
